const eventTypes = ['pointermove', 'touchmove', 'scroll', 'mousedown', 'mousemove', 'keypress']

export const addEventListeners = (listener: EventListenerOrEventListenerObject) => {
  eventTypes.forEach((type) => window.addEventListener(type, listener, false))
}

export const removeEventListeners = (listener: EventListenerOrEventListenerObject) => [
  eventTypes.forEach((type) => window.removeEventListener(type, listener, false)),
]
